/** The class to support attributes of Entity */
export class Attribute {
    /** this in the index of where the attribute is positioned in the attribute array of the entity */
    bind(index) {
        if (this.entity)
            this.entity.setAttr(index, this);
    }
    /** The arguments are the underlying entity and the attribute index in the attribute array */
    constructor(entity, index) {
        this.entity = entity;
        this.bind(index);
    }
}
//# sourceMappingURL=attribute.js.map